// Import necessary modules
import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { useLocation, useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles(theme => ({
    root: {
      padding: theme.spacing(3)
    },
    content: {
      marginTop: theme.spacing(2)
    },
    uiProgess: {
          position: 'fixed',
          zIndex: '1000',
          height: '31px',
          width: '31px',
          left: '50%',
          top: '35%'
      },
      progressContainer: {
        height: '100vh', // Take full height of the viewport
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
  }));

// Decodes the base64 'url' param; returns it only if it is a valid https URL,
// so values like 'javascript:' can't run script on our origin.
export const decodeRedirectUrl = (encodedUrl) => {
  try {
    const url = new URL(atob(encodedUrl));
    return url.protocol === 'https:' ? url.href : null;
  } catch (e) {
    return null;
  }
};

const H5WechatPay = () => {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    // Function to get the query parameter
    const getQueryParam = (param) => {
      const queryParams = new URLSearchParams(location.search);
      return queryParams.get(param);
    };

    // Extract the 'url' query parameter
    const encodedUrl = getQueryParam('url');
    const decodedUrl = encodedUrl ? decodeRedirectUrl(encodedUrl) : null;
    if (decodedUrl) {
      // Redirect to the decoded URL
      window.location.href = decodedUrl;
    } else {
      // Handle the case where 'url' parameter is not present or is invalid
      console.error('URL parameter is missing or invalid.');
    }
  }, [location, history]);

  return (

    <div className={classes.progressContainer}>
      <CircularProgress size={150}/>
    </div>
    // <CircularProgress size={150} className={classes.progressContainer} />
  );
};

export default H5WechatPay;
